// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAnimateNumber from "vue-animate-number";
import animated from "animate.css";
import App from "./App";
import router from "./router";
import "./config/rem";
import dragscroll from "./../static/directives";
import AmapVue from "@amap/amap-vue";
import VueAMap from "vue-amap";
import locale from "element-ui/lib/locale/lang/en";

Vue.directive("dragscroll", dragscroll);
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(ElementUI);
Vue.use(VueAnimateNumber);
Vue.use(animated);
Vue.use(AmapVue);
Vue.use(VueAMap);
// const fs= require('fs')
// console.log(geoip,"geoip___________________")
// const ip = require("ip");
// console.log(ip,"ip")
// const clientIp = ip.address();
// console.log(clientIp,"clientIp")
// let geoip = require("geoip-lite");
// const country = geoip.lookup(clientIp);
// if (country.country === "CN") {
//   // next("/local");
//
// } else {
//
// }
VueAMap.initAMapApiLoader({
  key: "76da2cc85b93557afdec3c7fc17c72eb",
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.Geolocation"
  ]
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
localStorage.setItem("language", "language");
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js